var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "bg-gray2" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _vm.showDigitalCartTooltip
              ? _c("div", { staticClass: "pt-1" }, [
                  _c("div", { staticClass: "row justify-content-end" }, [
                    _c(
                      "div",
                      { staticClass: "col-auto" },
                      [
                        _c("digital-cart-tooltip", {
                          attrs: {
                            title:
                              _vm.mobileDetails.digitalCartTooltipDto.title,
                            content:
                              _vm.mobileDetails.digitalCartTooltipDto.content,
                            "cta-label":
                              _vm.mobileDetails.digitalCartTooltipDto.ctaLabel,
                            "cta-url":
                              _vm.mobileDetails.digitalCartTooltipDto
                                .cartPageUrl,
                            "empty-cart":
                              _vm.mobileDetails.digitalCartTooltipDto.emptyCart,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedOffer && _vm.hasOfferFromUrl
              ? _c("selected-offer", {
                  staticClass: "mt-2 mb-1 d-webview-none",
                  attrs: {
                    title: _vm.selectedOffer.title,
                    "continue-without-mobile":
                      _vm.selectedOffer.continueWithoutMobile,
                    "modify-mobile-label": _vm.selectedOffer.modifyMobileLabel,
                    "modify-offer": _vm.selectedOffer.modifyOffer,
                    "offer-label": _vm.selectedOffer.offerLabel,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-1" },
              [
                _c("ob1-liens", {
                  attrs: {
                    href: "#",
                    text: _vm.mobileDetails.back.label,
                    "is-back": true,
                    "with-arrow": true,
                  },
                  on: { "ob1-liens-click": _vm.handleBackLink },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.mobileDetails.contractInfos && !_vm.selectedOffer
              ? _c("contract-phone-lines", {
                  staticClass: "mb-md-1 my-lg-1",
                  attrs: { "contract-infos": _vm.mobileDetails.contractInfos },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileDetails.incentiveDto && !_vm.selectedOffer
              ? _c("incentive", {
                  attrs: {
                    title: _vm.mobileDetails.incentiveDto.question,
                    text: _vm.mobileDetails.incentiveDto.message,
                    "link-href":
                      _vm.mobileDetails.currentVersion.advantagesLabels.href,
                    "link-label": _vm.mobileDetails.incentiveDto.linkLabel,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileDetails.intentionSwitchDto
              ? _c("intention-switch", {
                  staticClass: "pb-1",
                  attrs: {
                    "shop-sosh": _vm.isSoshShop,
                    title: _vm.mobileDetails.intentionSwitchDto.title,
                    "inline-alert": _vm.mobileDetails.pcmoaInfoMessage,
                    "acquisition-label":
                      _vm.mobileDetails.intentionSwitchDto.acquisitionLabel,
                    "tseul-label":
                      _vm.mobileDetails.intentionSwitchDto.tseulLabel,
                    "renewal-label":
                      _vm.mobileDetails.intentionSwitchDto.renewalLabel,
                    "changer-de-mobile-label":
                      _vm.mobileDetails.intentionSwitchDto.changerDeMobileLabel,
                    "default-intention-checked": _vm.intentionParam,
                  },
                  on: {
                    "switch-intention": function ($event) {
                      return _vm.switchIntention($event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.currentVersion.customerPopinDto
              ? [
                  _c("customer-popin", {
                    attrs: {
                      id: "customer-popin-id",
                      title:
                        _vm.currentVersion.customerPopinDto
                          .customerPopinLabelsDto.title,
                      text: _vm.currentVersion.customerPopinDto
                        .customerPopinLabelsDto.text,
                      "button-label":
                        _vm.currentVersion.customerPopinDto
                          .customerPopinLabelsDto.buttonLabel,
                      "button-link":
                        _vm.currentVersion.customerPopinDto
                          .customerPopinLinksDto.buttonLink,
                      "link-label-html":
                        _vm.currentVersion.customerPopinDto
                          .customerPopinLabelsDto.linkLabelHtml,
                      link: _vm.currentVersion.customerPopinDto
                        .customerPopinLinksDto.link,
                    },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column flex-md-row mt-1" },
              [
                _vm.currentVersion
                  ? _c("h1", { staticClass: "mb-0 mb-md-1 me-md-1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.currentVersion.constructorName) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayRatings
                  ? _c("Rating", {
                      staticClass:
                        "item-summary align-items-end align-items-xl-start mt-0 mt-xl-1 mb-1 mb-md-0",
                      attrs: {
                        average: _vm.currentVersion.reviewsStats.average,
                        text:
                          "(" +
                          _vm.currentVersion.reviewsStats.count +
                          " avis)",
                        "rating-results-height": 1.375,
                        link: "#anchor-reviews",
                      },
                      on: {
                        "ob1-rating-link": function ($event) {
                          $event.preventDefault()
                          return _vm.scrollToPageMenuAnchor("anchor-reviews")
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column flex-md-row bg-white" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column info-device-width border-right-md border-gray2",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "px-1 px-lg-2 py-1" },
                      [
                        _vm.currentVersion
                          ? _c(
                              "div",
                              { staticClass: "item-img" },
                              [
                                _c("ob1-carrousel", {
                                  key:
                                    "device-gallery-" +
                                    _vm.currentVersion.seoId.value,
                                  attrs: {
                                    id: "device-gallery",
                                    images: _vm.currentVersion.galleries,
                                    "is-product-sheet": true,
                                    "is-device-product-sheet": true,
                                    "image-rec-label-overlay":
                                      _vm.currentVersion.recqLabelImage,
                                    "rec-label-redirection-url":
                                      _vm.currentVersion
                                        .recqLabelRedirectionUrl,
                                    "with-zoom": true,
                                    "with-thumbnails": true,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.asilage
                          ? _c("ob1-separateur", { staticClass: "my-1" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.asilage
                          ? _c("asilage", {
                              attrs: {
                                title: _vm.asilage.title,
                                condition: _vm.asilage.condition,
                                "form-url": _vm.asilage.formUrl,
                                image: _vm.asilage.image,
                                "condition-label": _vm.asilage.conditionLabel,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("view-counter", {
                          attrs: {
                            "counter-threshold":
                              _vm.mobileDetails.views.counterThreshold,
                            "counter-delay":
                              _vm.mobileDetails.views.counterDelay,
                            "message-template": _vm.mobileDetails.views.message,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "w-100" }, [
                  _c(
                    "div",
                    { staticClass: "px-1 px-md-2 py-1" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-md-flex justify-content-md-between flex-wrap",
                        },
                        [
                          _vm.showDeclinaisonName
                            ? _c("h2", {
                                staticClass:
                                  "fw-bold no-signature standard mb-0 mb-lg-1 me-2",
                                domProps: { innerHTML: _vm._s(_vm.subtitle) },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.esimOnlyInfoLabel && _vm.esimOnlyInfoDescription
                            ? _c("div", { staticClass: "ob1-tooltip mb-1" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "ob1-tooltip-trigger ob1-link-icon ob1-link-icon-small",
                                    attrs: { type: "button" },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "icon icon-SIM-E",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "ob1-link-icon-text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.esimOnlyInfoLabel
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ob1-tooltip-content py-0",
                                    class: _vm.esimOnlyTooltipPosition,
                                  },
                                  [
                                    _vm.esimOnlyInfoDescription
                                      ? _c("div", {
                                          staticClass:
                                            "fw-bold no-signature standard",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.esimOnlyInfoDescription
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.allColors.length > 0
                        ? _c("ob1-pastilles-de-couleurs", {
                            staticClass: "mb-1",
                            class: !_vm.showDeclinaisonName ? "mt-2" : null,
                            attrs: {
                              id: "colors",
                              colors: _vm.allColors,
                              "default-color": _vm.mobileDetails.currentVersion
                                .color
                                ? _vm.mobileDetails.currentVersion.color.code
                                : null,
                            },
                            on: {
                              "ob1-pastilles-de-couleurs-click":
                                _vm.changeSelectedColor,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "fieldset",
                        [
                          _c("legend", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                                Capacités disponibles\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.allCapacitiesBySelectedColor,
                            function (capacity, index) {
                              return _c("ob1-chips", {
                                key: "capacity-" + index,
                                attrs: {
                                  id: "capacity-" + index,
                                  "is-choice-version": true,
                                  label: capacity.capacity,
                                  "is-disabled":
                                    !capacity.availableOnlineOrEresa,
                                  "is-checked": capacity.isChecked,
                                  "disable-uncheck": true,
                                  "additional-classes": "mb-1",
                                },
                                on: {
                                  "ob1-chips-click": _vm.changeSelectedCapacity,
                                },
                              })
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.allGradesBySelectedCapacityColor.length > 0
                        ? _c("ob1-separateur", {
                            staticClass: "d-md-none mb-2 mt-1",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allGradesBySelectedCapacityColor.length > 0
                        ? _c(
                            "fieldset",
                            { staticClass: "mt-md-1" },
                            [
                              _c("legend", { staticClass: "visually-hidden" }, [
                                _vm._v(
                                  "\n                                Etat du mobile Reconditionné\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.allGradesBySelectedCapacityColor,
                                function (grade, index) {
                                  return _c("ob1-chips", {
                                    key: "grade-" + index,
                                    attrs: {
                                      id: "grade-" + index,
                                      "is-choice-version": true,
                                      label: grade.grade.label,
                                      "is-disabled":
                                        !grade.availableOnlineOrEresa,
                                      "is-checked": grade.isChecked,
                                      "disable-uncheck": true,
                                      "additional-classes": "mb-1",
                                    },
                                    on: {
                                      "ob1-chips-click": function ($event) {
                                        return _vm.changeSelectedGrade(
                                          grade.grade.value
                                        )
                                      },
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allGradesBySelectedCapacityColor.length > 0
                        ? [
                            _c("ob1-liens", {
                              staticClass: "pt-0",
                              attrs: {
                                "is-button": "",
                                "with-arrow": true,
                                "data-bs-toggle": "modal",
                                "modal-id": "gradeModal",
                                text: "Pour en savoir plus, c'est par ici",
                                "data-oevent-category":
                                  "comment_choisir_son_reconditionné",
                                "data-oevent-action": _vm.getAction(),
                                "data-oevent-label": "vers_popin",
                              },
                            }),
                            _vm._v(" "),
                            _c("grade-popin", {
                              attrs: {
                                "modal-id": "gradeModal",
                                "default-grade-id":
                                  _vm.currentVersion.grade.label,
                                labels: _vm.mobileDetails.gradeLabelsDto,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allBatteriesBySelectedGradeCapacityColor.length > 0
                        ? _c("ob1-separateur", {
                            staticClass: "d-md-none mb-2 mt-1",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allBatteriesBySelectedGradeCapacityColor.length > 0
                        ? _c(
                            "fieldset",
                            { staticClass: "my-md-1" },
                            [
                              _c("legend", { staticClass: "visually-hidden" }, [
                                _vm._v(
                                  "\n                                Etat de la batterie\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.allBatteriesBySelectedGradeCapacityColor,
                                function (battery, index) {
                                  return _c("ob1-chips", {
                                    key: "battery-" + index,
                                    attrs: {
                                      id: "battery-" + index,
                                      "is-choice-version": true,
                                      "is-disabled":
                                        !battery.availableOnlineOrEresa,
                                      label: battery.battery.label,
                                      "is-checked": battery.isChecked,
                                      "disable-uncheck": true,
                                      "additional-classes": "mb-1",
                                    },
                                    on: {
                                      "ob1-chips-click": function ($event) {
                                        return _vm.changeSelectedBattery(
                                          battery.battery.value
                                        )
                                      },
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loading
                        ? _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("ob1-progress-indicators", {
                                attrs: { size: 50, type: "undetermined" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.priceInfos
                        ? [
                            _c("ob1-separateur", { staticClass: "my-1" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-lg-flex justify-content-between",
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _vm.priceInfos.banner
                                      ? _c("ob1-tag", {
                                          attrs: {
                                            label: _vm.priceInfos.banner,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.priceDevicePromoLabel
                                      ? _c("promo-prix-terminal", {
                                          staticClass: "mt-1",
                                          attrs: {
                                            "promo-label":
                                              _vm.priceDevicePromoLabel,
                                            "promo-end-date":
                                              _vm.priceDevicePromoEndDate,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("device-price", {
                                      staticClass: "d-block",
                                      attrs: {
                                        "multiple-price":
                                          _vm.priceInfos.price.multiplePrice,
                                        "total-price-with-promo":
                                          _vm.priceInfos.price
                                            .totalPriceWithPromo,
                                        "total-price-without-promo":
                                          _vm.priceInfos.price
                                            .totalPriceWithoutPromo,
                                        "monthly-amount-in-cents": _vm
                                          .priceInfos.price.monthlyPayment
                                          ? _vm.priceInfos.price.monthlyPayment
                                              .monthlyAmountInCents
                                          : null,
                                        "monthly-duration": _vm.priceInfos.price
                                          .monthlyPayment
                                          ? _vm.priceInfos.price.monthlyPayment
                                              .duration
                                          : null,
                                        "taeg-rate": _vm.priceInfos.price
                                          .monthlyPayment
                                          ? _vm.priceInfos.price.monthlyPayment
                                              .taegRate
                                          : null,
                                        "generic-label": _vm.priceInfos.price
                                          .monthlyPayment
                                          ? _vm.priceInfos.price.monthlyPayment
                                              .genericLabel
                                          : null,
                                        "loan-rate-zero-label":
                                          _vm.getLoanRateZeroLabel(
                                            _vm.priceInfos.price
                                          ),
                                        "is-cents-format": true,
                                        "is-price-inversion-enabled":
                                          _vm.isPriceInversionEnabledForDevice(
                                            _vm.priceInfos.price
                                          ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.priceInfos.price.paymentInfoLabel
                                      ? _c("cb4x-pxf-mention", {
                                          attrs: {
                                            "payment-info-detail":
                                              _vm.priceInfos.price
                                                .paymentInfoLabel.detail,
                                            "link-label":
                                              _vm.mobileDetails
                                                .paymentSolutionsDto.linkLabel,
                                            "modal-id": "popin-pxf-4xcb",
                                            "is-from-mobile-detail": "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("pxf-cb4x-modal", {
                                      attrs: {
                                        "modal-id": "popin-pxf-4xcb",
                                        "display-cb4x":
                                          _vm.priceInfos.price.cb4xAvailable,
                                        "display-pxf":
                                          _vm.priceInfos.price.pxfAvailable,
                                        "device-name":
                                          _vm.currentVersion.brand +
                                          " " +
                                          _vm.currentVersion.declinaisonName,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          _vm.priceInfos.price.cb4xAvailable
                                            ? {
                                                key: "cb4x-content",
                                                fn: function () {
                                                  return [
                                                    _vm.fundingDetailsDto
                                                      .cb4xPopin.withFees
                                                      ? _c(
                                                          "paying-detail-cb4x-modal-content",
                                                          {
                                                            attrs: {
                                                              "modal-id":
                                                                "popin-pxf-4xcb",
                                                              "oney-merchant-guid":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .oneyMerchantGuid,
                                                              "oney-widget-src":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .oneyWidgetSrc,
                                                              "counter-delay":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .counterDelay,
                                                              amount:
                                                                _vm.priceInfos
                                                                  .price
                                                                  .totalPriceWithPromo /
                                                                100,
                                                              "header-block":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .headerBlock,
                                                              "how-to-benefit":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .howToBenefit,
                                                              cgu: _vm
                                                                .fundingDetailsDto
                                                                .cb4xPopin.cgu,
                                                              illustration:
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .imageZen,
                                                            },
                                                          }
                                                        )
                                                      : _vm.priceInfos.price
                                                          .spreadingPrice4xCbWithoutFees
                                                      ? _c(
                                                          "cb4x-modal-content",
                                                          {
                                                            attrs: {
                                                              "header-block":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .headerBlock,
                                                              "payment-block":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .paymentBlock,
                                                              "payment-simulation-block":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .paymentSimulationBlock,
                                                              "how-to-benefit":
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .howToBenefit,
                                                              faq: _vm
                                                                .fundingDetailsDto
                                                                .cb4xPopin
                                                                .faqBlock,
                                                              cgu: _vm
                                                                .fundingDetailsDto
                                                                .cb4xPopin.cgu,
                                                              "monthly-price":
                                                                _vm.priceInfos
                                                                  .price
                                                                  .spreadingPrice4xCbWithoutFees
                                                                  .monthlyPrice,
                                                              "first-monthly-price":
                                                                _vm.priceInfos
                                                                  .price
                                                                  .spreadingPrice4xCbWithoutFees
                                                                  .firstMonthlyPrice,
                                                              "one-shot-price":
                                                                _vm.priceInfos
                                                                  .price
                                                                  .spreadingPrice4xCbWithoutFees
                                                                  .oneShotPrice,
                                                              illustration:
                                                                _vm
                                                                  .fundingDetailsDto
                                                                  .cb4xPopin
                                                                  .imageZen,
                                                            },
                                                          }
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                          _vm.priceInfos.price.pxfAvailable
                                            ? {
                                                key: "pxf-content",
                                                fn: function () {
                                                  return [
                                                    _c("pxf-modal-content", {
                                                      attrs: {
                                                        "header-block-dto":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .headerBlockDto,
                                                        "example-pxf-data":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .examplePxfData,
                                                        "example-pxf-tab-subtitle":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .examplePxfTabSubtitle,
                                                        "example-pxf-tab-title":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .examplePxfTabTitle,
                                                        "version-pxf-data":
                                                          _vm.priceInfos.price
                                                            .versionPxfData,
                                                        "version-pxf-tab-title":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .versionPxfTabTitle,
                                                        "pxf-legal-mentions-text":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .pxfLegalMentionsText,
                                                        illustration:
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin.imageZen,
                                                        "financing-block":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .financingBlock,
                                                        cgu: _vm
                                                          .fundingDetailsDto
                                                          .pxfPopin.cguDto,
                                                        "how-to-benefit-dto":
                                                          _vm.fundingDetailsDto
                                                            .pxfPopin
                                                            .howToBenefitDto,
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.currentVersionDataForIntention &&
                            _vm.currentVersionDataForIntention
                              .complementaryPriceLabel
                              ? _c("p", {
                                  staticClass: "pb-0",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVersionDataForIntention
                                        .complementaryPriceLabel
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVersion.ecoParticipationDTO
                              ? _c("eco-part-private-copying", {
                                  attrs: {
                                    id:
                                      _vm.currentVersion.ecoParticipationDTO
                                        .ecoParticipationModal.id + "-modal",
                                    "eco-part-label":
                                      _vm.currentVersion.ecoParticipationDTO
                                        .ecoParticipationLabel,
                                    "eco-part-link-label":
                                      _vm.currentVersion.ecoParticipationDTO
                                        .ecoParticipationLinkLabel,
                                    "eco-part-modal":
                                      _vm.currentVersion.ecoParticipationDTO
                                        .ecoParticipationModal,
                                    "private-copying-label":
                                      _vm.currentVersion.ecoParticipationDTO
                                        .privateCopyingLabel,
                                    "private-copying-link":
                                      _vm.currentVersion.ecoParticipationDTO
                                        .privateCopyingLink,
                                    "private-copying-link-label":
                                      _vm.currentVersion.ecoParticipationDTO
                                        .privateCopyingLinkLabel,
                                    target:
                                      _vm.currentVersion.ecoParticipationDTO
                                        .ecoParticipationModal.target,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mobileDetails.showGuaranteeLegalMentions
                              ? _c("div", { staticClass: "small" }, [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.mobileDetails
                                          .guaranteeLegalMentionsLabel
                                      ),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVersionDataForIntention &&
                            _vm.currentVersionDataForIntention.commitment
                              ? _c(
                                  "div",
                                  { staticClass: "pt-1" },
                                  [
                                    _c("ob1-message-alerte", {
                                      attrs: {
                                        title:
                                          _vm.currentVersionDataForIntention
                                            .commitment.text,
                                        type: "info",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "col-12 pt-2 px-0 bg-white" },
                              [
                                !_vm.loading
                                  ? _c("ob1-message-alerte", {
                                      attrs: {
                                        "is-simple-alerte": false,
                                        title:
                                          _vm.mobileDetails.alertStatusDto
                                            .title,
                                        text: _vm.mobileDetails.alertStatusDto
                                          .message,
                                        type: "warning",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.currentVersion && _vm.currentVersionDataForIntention
                    ? _c(
                        "div",
                        { staticClass: "px-1 px-md-2 pb-1" },
                        [
                          _vm.priceInfos && _vm.priceInfos.advantages
                            ? [
                                _c("refunds", {
                                  attrs: {
                                    odrs: _vm.priceInfos.advantages.odrData,
                                    "device-seo-id":
                                      _vm.currentVersion.seoId.value,
                                    "refund-messages":
                                      _vm.mobileDetails.refundMessages,
                                    recovery:
                                      _vm.priceInfos.advantages.recovery,
                                    "total-amount-in-cents":
                                      _vm.priceInfos.advantages
                                        .totalAmountInCents,
                                    "advantages-label":
                                      _vm.priceInfos.advantages.label,
                                    "simulator-modal-id": _vm.simulatorModalId,
                                    "simulator-result-modal-id":
                                      _vm.savedSimulationResultModalId,
                                    "recovery-modal-id": _vm.recoveryModalId,
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasRecovery
                                  ? [
                                      _c("mobile-recovery-simulator-modal", {
                                        attrs: {
                                          "modal-id": _vm.simulatorModalId,
                                          shop: _vm.shop,
                                          messages:
                                            _vm.mobileDetails.refundMessages
                                              .recoverySimulator,
                                        },
                                        on: {
                                          "update-recovery-simulation":
                                            _vm.updateRecoveryPrice,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.priceInfos.advantages.recovery
                                        .manualEstimation
                                        ? _c(
                                            "mobile-recovery-simulation-result-modal",
                                            {
                                              attrs: {
                                                "modal-id":
                                                  _vm.savedSimulationResultModalId,
                                                shop: _vm.shop,
                                                messages:
                                                  _vm.mobileDetails
                                                    .refundMessages
                                                    .recoverySimulator.result,
                                                "estimated-device-price-in-cents":
                                                  _vm.priceInfos.advantages
                                                    .recovery.amountInCents,
                                                "estimated-device-model":
                                                  _vm.priceInfos.advantages
                                                    .recovery.deviceModel,
                                                bonus:
                                                  _vm.priceInfos.advantages
                                                    .recovery.bonus,
                                                "online-recovery-available":
                                                  _vm
                                                    .currentVersionDataForIntention
                                                    .onlineRecoveryAvailable,
                                              },
                                              on: {
                                                "new-simulation":
                                                  _vm.newSimulation,
                                                "save-simulation":
                                                  _vm.saveSimulation,
                                              },
                                            }
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "mobile-recovery-simulation-result-modal",
                                        {
                                          attrs: {
                                            "modal-id":
                                              _vm.currentSimulationResultModalId,
                                            shop: _vm.shop,
                                            messages:
                                              _vm.mobileDetails.refundMessages
                                                .recoverySimulator.result,
                                            "estimated-device-price-in-cents":
                                              _vm.estimatedDevice
                                                .recoveryPriceInCents,
                                            "estimated-device-model":
                                              _vm.estimatedDevice.model,
                                            bonus:
                                              _vm.priceInfos.advantages.recovery
                                                .bonus,
                                            "online-recovery-available":
                                              _vm.currentVersionDataForIntention
                                                .onlineRecoveryAvailable,
                                          },
                                          on: {
                                            "new-simulation": _vm.newSimulation,
                                            "save-simulation":
                                              _vm.saveSimulation,
                                          },
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c("mobile-recovery-details-modal", {
                                        attrs: {
                                          "modal-id": _vm.recoveryModalId,
                                          "infos-recovery":
                                            _vm.mobileDetails.refundMessages
                                              .recoveryModal.infosRecovery,
                                          "online-recovery": _vm
                                            .currentVersionDataForIntention
                                            .onlineRecoveryAvailable
                                            ? _vm.mobileDetails.refundMessages
                                                .recoveryModal.onlineRecovery
                                            : null,
                                          "store-recovery": _vm
                                            .currentVersionDataForIntention
                                            .eligibleEresa
                                            ? _vm.mobileDetails.refundMessages
                                                .recoveryModal.storeRecovery
                                            : null,
                                          "bonus-recovery":
                                            _vm.mobileDetails.refundMessages
                                              .recoveryModal.bonusRecovery,
                                          bonus:
                                            _vm.priceInfos.advantages.recovery
                                              .bonus,
                                          "recovery-simulator":
                                            _vm.mobileDetails.refundMessages
                                              .recoverySimulator,
                                          "simulator-button-label":
                                            _vm.mobileDetails.refundMessages
                                              .simulatorButtonLabel,
                                          "bonus-amount": _vm.bonusAmountFormat,
                                          "simulator-modal-id":
                                            _vm.simulatorModalId,
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.priceInfos
                            ? _c("mobile-details-cta-acquisition", {
                                attrs: {
                                  "alert-status-dto":
                                    _vm.mobileDetails.alertStatusDto,
                                  "button-label": _vm.ctaLabel(),
                                  "all-disponibilities-popin":
                                    _vm.mobileDetails
                                      .allDisponibilitiesPopinLabelsDto,
                                  "preorder-mention":
                                    _vm.currentVersion.preorderMention,
                                  "available-online":
                                    _vm.currentVersionDataForIntention
                                      .inStockOnline,
                                  "estimated-delivery-label":
                                    _vm.currentVersionDataForIntention
                                      .estimatedDeliveryLabel,
                                  "available-eresa":
                                    _vm.currentVersionDataForIntention
                                      .eligibleEresa,
                                  "offers-href": _vm.offersHref,
                                  "offers-client-href":
                                    _vm.currentVersionDataForIntention
                                      .chooseAuthenticatedOfferWithDeviceHref,
                                  "eresa-href":
                                    _vm.currentVersionDataForIntention
                                      .eresaOrderHref,
                                  "online-href": _vm.onlineOrderHref,
                                  "online-client-href":
                                    _vm.onlineAuthenticatedOrderHref,
                                  "authentication-popin-labels":
                                    _vm.mobileDetails
                                      .authenticationPopinLabelsDto,
                                  "with-digital-cart-internet":
                                    _vm.withDigitalCartInternet,
                                  "has-offer-from-url": _vm.hasOfferFromUrl,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVersion.advantagesLabels &&
                          _vm.displayAdvantageMessage
                            ? _c("mobile-details-advantages", {
                                attrs: {
                                  "is-authenticated": _vm.isAuthenticated,
                                  labels: _vm.currentVersion.advantagesLabels,
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      (_vm.currentVersion &&
        _vm.currentVersion.repairability &&
        _vm.currentVersion.repairability.picto) ||
      _vm.mobileDetails.dasDTO
        ? _c("div", { staticClass: "pt-1 pt-md-2 bg-gray2" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row align-items-center pb-1" }, [
                _vm.mobileDetails.dasDTO
                  ? _c(
                      "div",
                      { staticClass: "col-12 col-md-auto" },
                      [
                        _c("das", {
                          staticClass: "my-1",
                          attrs: {
                            head: _vm.mobileDetails.dasDTO.head,
                            trunk: _vm.mobileDetails.dasDTO.trunk,
                            member: _vm.mobileDetails.dasDTO.member,
                            prefix: _vm.mobileDetails.dasDTO.prefix,
                            "popin-title": _vm.mobileDetails.dasDTO.popinTitle,
                            "popin-text":
                              _vm.mobileDetails.dasDTO.popinDescription,
                            "is-sosh-shop": _vm.isSoshShop,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentVersion.chargerIncluded
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("div", {
                              staticClass:
                                "icon icon-charger-availability charger-icon-size ps-1 ps-md-0 text-gray4",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c("strong", {
                              staticClass: "ps-3 ps-md-0",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVersion.chargerIncludedMessage
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm.currentVersion.chargerCompatibleInfos
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0",
                      },
                      [
                        _c("ChargerInfos", {
                          attrs: {
                            "is-sosh-shop": _vm.isSoshShop,
                            "charger-infos":
                              _vm.currentVersion.chargerCompatibleInfos,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentVersion &&
                _vm.currentVersion.repairability &&
                _vm.currentVersion.repairability.picto
                  ? _c(
                      "div",
                      { staticClass: "col-12 col-md-auto" },
                      [
                        _c("repairability", {
                          attrs: {
                            picto: _vm.currentVersion.repairability.picto,
                            note: _vm.currentVersion.repairability.note,
                            label:
                              _vm.mobileDetails.repairabilityMessagesDto.label,
                            "title-popin":
                              _vm.mobileDetails.repairabilityMessagesDto.label,
                            "text-popin":
                              _vm.mobileDetails.repairabilityMessagesDto
                                .textPopin,
                            "link-document":
                              _vm.mobileDetails.repairabilityMessagesDto
                                .linkDocument,
                            "url-document":
                              _vm.currentVersion.repairability.urlDocument,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentVersion.energyLabel
                  ? _c(
                      "div",
                      { staticClass: "col-12 col-md-auto" },
                      [
                        _c("energy-label", {
                          attrs: {
                            "energy-label": _vm.currentVersion.energyLabel,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _vm.shouldDisplayPXFMention
            ? _c(
                "section",
                [
                  _c("pxf-description", {
                    attrs: {
                      "pxf-legal-mentions-text": _vm.pxfLegalMentionsText,
                    },
                  }),
                  _vm._v(" "),
                  _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("financing-mentions", {
                          attrs: {
                            "financing-mentions":
                              _vm.fundingDetailsDto.pxfPopin.financingBlock,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("skeleton-mobiles-views-history-card")],
                1
              )
            : [
                _vm.mobilesViewsHistory
                  ? _c("mobiles-views-history", {
                      attrs: {
                        title: _vm.navigationHistoryTitle,
                        "track-zone": _vm.viewedMobilesTag,
                        mobiles: _vm.mobilesViewsHistory.mobiles,
                        "is-from-mobile-detail": "",
                        intention: _vm.intentionParam,
                      },
                    })
                  : _vm._e(),
              ],
          _vm._v(" "),
          _vm.pageMenu
            ? _c("ob1-page-menu", {
                staticClass: "sticky bg-white mb-2",
                attrs: { id: "device-details-page-menu", tabs: _vm.pageMenu },
                on: { "ob1-page-menu-click": _vm.scrollToPageMenuAnchor },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileDetails.pushZigZagDTO
            ? _c(
                "section",
                [
                  _c("div", { staticClass: "mb-xl-3" }),
                  _vm._v(" "),
                  _c("header-signature", {
                    attrs: { text: _vm.mobileDetails.essentialTitle },
                  }),
                  _vm._v(" "),
                  _c("EditorialPush", {
                    attrs: { zigzag: _vm.mobileDetails.pushZigZagDTO },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.technicalSheet
            ? _c(
                "section",
                [
                  _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                  _vm._v(" "),
                  _c("technical-sheet", {
                    attrs: {
                      "technical-sheet-dto": _vm.currentVersion.technicalSheet,
                      "refurbished-characteristic-dto":
                        _vm.currentVersion.refurbishedCharacteristicDTO,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRecovery
            ? [
                _c(
                  "section",
                  { staticClass: "mb-2 mb-md-3" },
                  [
                    _c("ob1-separateur", { staticClass: "my-2" }),
                    _vm._v(" "),
                    _c("header-signature", {
                      attrs: { text: _vm.mobileRecovery.messages.title },
                    }),
                    _vm._v(" "),
                    _c("mobile-recovery", {
                      attrs: {
                        id: "anchor-mobile-recovery",
                        "recovery-amount-in-cents": _vm.recoveryAmountInCents,
                        "recovery-device-model": _vm.recoveryDeviceModel,
                        "manual-estimation": _vm.recoveryManualEstimation,
                        "bonus-amount-in-cents": _vm.bonusAmountInCents,
                        "simulator-modal-id": _vm.simulatorModalId,
                        "recovery-modal-id": _vm.recoveryModalId,
                        messages: _vm.mobileRecovery.messages,
                        visual: _vm.mobileRecovery.visual,
                        shop: _vm.shop,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileDetails.showGuaranteeLegalMentions
            ? _c(
                "section",
                [
                  _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                  _vm._v(" "),
                  _c("guarantee-legal-mentions", {
                    attrs: { "legal-mentions": _vm.deviceMentions },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion && _vm.currentVersion.ecoRating
            ? _c(
                "section",
                [
                  _c("eco-rating", {
                    attrs: { "eco-rating": _vm.currentVersion.ecoRating },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileDetails.showRetailLegalMentions
            ? [
                _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                _vm._v(" "),
                _c("header-signature", {
                  attrs: { text: _vm.mobileDetails.retailLegalMentionsTitle },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row align-items-baseline",
                    attrs: { id: "anchor-reconditioned" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12 d-flex align-items-center mb-1" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.deviceMentions.retailMentiontext
                            ),
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.displayRatings
            ? [
                _c(
                  "section",
                  { staticClass: "mb-2 mb-md-3" },
                  [
                    _c("ob1-separateur", { staticClass: "my-2" }),
                    _vm._v(" "),
                    _c("header-signature", {
                      attrs: { text: _vm.mobileDetails.reviewsMessages.title },
                    }),
                    _vm._v(" "),
                    _c("device-average-rating-reviews", {
                      attrs: {
                        "reviews-stats-average":
                          _vm.currentVersion.reviewsStats.average,
                        "review-count": _vm.currentVersion.reviewsStats.count,
                        "reviews-messages": _vm.mobileDetails.reviewsMessages,
                        summary: _vm.currentVersion.summary,
                      },
                    }),
                    _vm._v(" "),
                    _c("device-filter-and-details-reviews", {
                      attrs: {
                        "device-details-reviews": _vm.deviceDetailsReviews,
                        "total-review-count":
                          _vm.currentVersion.reviewsStats.count,
                        "device-filter-reviews": _vm.deviceFilterReviews,
                        "reviews-messages": _vm.mobileDetails.reviewsMessages,
                        "ratings-filter-checkboxes":
                          _vm.ratingsFilterCheckboxes,
                        "date-sort-radio-buttons": _vm.dateSortRadioButtons,
                      },
                      on: {
                        "update-ratings-filter-handler":
                          _vm.updateRatingsFilterHandler,
                        "review-date-sort-item-click":
                          _vm.reviewDateSortHandler,
                        "more-device-reviews": _vm.getMoreDeviceReviews,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileDetails.environmentalQuality
            ? _c("ob1-liens", {
                staticClass: "mw-100 py-0",
                attrs: {
                  href: _vm.mobileDetails.environmentalQuality.url,
                  text: _vm.mobileDetails.environmentalQuality.linkLabel,
                  "with-arrow": true,
                  "is-mini": true,
                  target: "_blank",
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bg-gray2 mt-1 pt-1 pb-1" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("free-hands", {
              attrs: { text: _vm.mobileDetails.freeHandsText },
            }),
            _vm._v(" "),
            _vm.priceInfos &&
            _vm.priceInfos.price.paymentInfoLabel &&
            _vm.priceInfos.price.paymentInfoLabel.type === "CB4X"
              ? _c("legal-mentions4x-cb", {
                  attrs: {
                    label: _vm.mobileDetails.legalMentions.cb4xMention,
                    "popin4x-cb": _vm.mobileDetails.legalMentions.popin4xCb,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isSoshShop
        ? _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c("sosh-commitments", {
                attrs: { commitments: _vm.mobileDetails.soshCommitments },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "bg-dark d-webview-none" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [
                _c("orange-commitments", {
                  attrs: { commitments: _vm.mobileDetails.orangeCommitments },
                }),
              ],
              1
            ),
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-webview-none",
          class: _vm.isSoshShop ? "bg-gray2 py-1" : "bg-dark py-1",
        },
        [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c("ob1-breadcrumb", {
                attrs: {
                  "is-inverse": !_vm.isSoshShop,
                  items: _vm.breadcrumbItems,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "savedSimulationSnackbar",
        attrs: {
          id: "simulation-snackbar",
          icon: "icon-tick-circle",
          label:
            _vm.mobileDetails.refundMessages.recoverySimulator.result
              .snackbarLabel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }